import { checklistClient } from '../../config/api';
import {
  ChecklistResponse,
  ChecklistResponseApiResponse,
  ChecklistResponsesApiResponse,
  SubmitChecklistResponseRequest,
} from '../types/checklist.types';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';

export class ResponseService {
  private readonly basePath = '/api/checklists';

  submitResponse = async (
    checklistId: string,
    data: SubmitChecklistResponseRequest
  ): Promise<ChecklistResponse> => {
    try {
      const response = await checklistClient.post<ChecklistResponseApiResponse>(
        `${this.basePath}/${checklistId}/responses`,
        data,
        { timeout: 120000 }
      );

      if (response.status === 200 || response.status === 201) {
        return {} as ChecklistResponse;
      }

      throw new Error(response.data?.errorMessage || 'Error submitting checklist response');
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error submitting checklist response');
    }
  };

  getResponsesByChecklistId = async (checklistId: string): Promise<ChecklistResponse[]> => {
    try {
      const response = await checklistClient.get<ChecklistResponsesApiResponse>(
        `${this.basePath}/${checklistId}/responses`
      );

      if (!response.data || !response.data.success) {
        throw new Error(response.data?.errorMessage || 'Error fetching responses');
      }

      return response.data.data || [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error fetching responses');
    }
  };

  getResponsesByInspectionId = async (
    checklistId: string,
    inspectionId: string
  ): Promise<ChecklistResponse[]> => {
    try {
      const response = await checklistClient.get<any>(
        `${this.basePath}/${checklistId}/responses/by-inspection/${inspectionId}`
      );

      // A API retorna diretamente um array, não envelopado em { success, data }
      if (Array.isArray(response.data)) {
        return response.data;
      }

      // Fallback para formato envelopado (se a API mudar no futuro)
      if (response.data && response.data.success && response.data.data) {
        return response.data.data || [];
      }

      throw new Error('Formato de resposta inesperado');
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error fetching responses');
    }
  };
}

export const responseService = new ResponseService();
